var $8d15e736e12d3dfd$exports = {};
$8d15e736e12d3dfd$exports = {
    "breadcrumbs": `\u{5BFC}\u{822A}\u{680F}`
};


export {$8d15e736e12d3dfd$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
